module.exports = __webpack_public_path__ + "static/media/ljpc_logo.627d9dfe.png";